<template>
    <!-- benefits -->
    <section class="benefit-section">
        <div class="container">
            <div class="section-header text-center">
                <span class="fw-medium text-secondary text-decoration-underline mb-2 d-inline-block">Keunggulan Kami</span>
                <h2>Kuasai Standar Teknis Perusahaan</h2>
                <p>Materi pelatihan yang disusun oleh ahli internal untuk memastikan standar kualitas kerja terbaik.</p>
            </div>
            <div class="row row-gap-4">
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm h-100 mb-0">
                        <div class="card-body p-4">
                            <div class="position-absolute top-0 end-0 mt-n3 me-n4">
                                <img src="@/assets/img/shapes/bg-1.png" alt="img">
                            </div>
                            <div class="p-4 rounded-pill bg-primary-transparent d-inline-flex">
                                <i class="isax isax-book-1 fs-24"></i>
                            </div>
                            <h5 class="mt-3 mb-1">Belajar Fleksibel</h5>
                            <p class="mb-0">Akses materi pelatihan kapan saja dan di mana saja, menyesuaikan dengan jadwal tugas lapangan Anda.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm h-100 mb-0">
                        <div class="card-body p-4">
                            <div class="position-absolute top-0 end-0 mt-n3 me-n4">
                                <img src="@/assets/img/shapes/bg-2.png" alt="img">
                            </div>
                            <div class="p-4 rounded-pill bg-secondary-transparent d-inline-flex">
                                <i class="isax isax-bookmark5 fs-24"></i>
                            </div>
                            <h5 class="mt-3 mb-1">Akses Selamanya</h5>
                            <p class="mb-0">Materi tetap dapat diakses sebagai referensi kerja selama Anda menjadi bagian dari tim Sapta.</p>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6">
                    <div class="card shadow-sm h-100 mb-0">
                        <div class="card-body p-4">
                            <div class="position-absolute top-0 end-0 mt-n3 me-n4">
                                <img src="@/assets/img/shapes/bg-3.png" alt="img">
                            </div>
                            <div class="p-4 rounded-pill bg-skyblue-transparent d-inline-flex">
                                <i class="isax isax-chart-26 fs-24"></i>
                            </div>
                            <h5 class="mt-3 mb-1">Instruktur Ahli</h5>
                            <p class="mb-0">Dibimbing langsung oleh senior dan praktisi berpengalaman yang memahami tantangan nyata di lapangan.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- benefits -->

    <!-- institutions -->
    <section class="client-section">
        <div class="container">
            <h6 class="fw-medium text-center mb-4">
                Our Partners: <span class="text-decoration-underline text-secondary">{{ partnerLogos.length }}+</span> Solution Partners
            </h6>
            <div class="institutions-slider lazy slider">
                <Carousel
                    :autoplay="2000"
                    :loop="true"
                    :wrap-around="true"
                    :settings="settings"
                    :breakpoints="breakpoints" 
                >
                    <Slide
                        v-for="item in partnerLogos"
                        :key="item.id"
                        class="lead-group-slider owl-carousel owl-theme"
                    >
                        <div class="institutions-items p-1">
                            <img class="img-fluid partner-logo-img" :src="item.src" :alt="item.name">
                        </div>
                    </Slide>
                </Carousel>
            </div>
        </div>
    </section>
    <!-- institutions -->
</template>

<script>
import { Carousel, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";

function loadPartnerLogos() {
    const context = require.context("@/assets/partners", false, /\.(png|jpe?g|svg)$/i);

    return context
        .keys()
        .sort((a, b) => a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" }))
        .map((key, index) => {
            const mod = context(key);
            const src = typeof mod === "string" ? mod : mod?.default;
            const name = key.replace("./", "");

            return {
                id: index + 1,
                src,
                name,
            };
        })
        .filter((item) => Boolean(item.src));
}

export default {
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            partnerLogos: loadPartnerLogos(),
        }
    },
    setup() {
        return {
        // carousel settings
        settings: {
            itemsToShow: 1,
            snapAlign: "center",
        },

        breakpoints: {
            // 700px and up
            700: {
                itemsToShow: 2,
                snapAlign: "center",
            },
            // 1024 and up
            1024: {
                itemsToShow: 6,
                snapAlign: "start",
            },
        },
        };
    },
}
</script>

<style scoped>
.partner-logo-img {
  max-width: 8vw;
}
@media (max-width: 991.98px) {
  .partner-logo-img {
    max-width: 40vw;
  }
}
</style>